import React from 'react';
import { Svg, Path } from "react-native-svg-web";


const IconDefaultProps = {
  size: '24px',
  color: '#333333' };


export const SignInIcon = ({
  className,
  size = IconDefaultProps.size,
  color = IconDefaultProps.color }) => /*#__PURE__*/

React.createElement(Svg, {

  className: className,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4142 12.002L10.9666 16.4496C10.5761 16.8401 9.94292 16.8401 9.5524 16.4496C9.16188 16.059 9.16188 15.4259 9.5524 15.0354L11.5858 13.002L2 13.002V11.002L11.5858 11.002L9.5524 8.96858C9.16188 8.57806 9.16188 7.94489 9.5524 7.55437C9.94292 7.16384 10.5761 7.16384 10.9666 7.55437L15.4142 12.002Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 21L11 21L11 19L19 19C19.5523 19 20 18.5523 20 18L20 6C20 5.44772 19.5523 5 19 5L11 5L11 3L19 3C20.6569 3 22 4.34315 22 6L22 18C22 19.6569 20.6569 21 19 21Z",
  fill: color }));